import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

export interface ISidebar {
  name: string;
  path: string;
}

function SidebarItem({ name, path }: ISidebar) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Item onClick={() => navigate(path)} selected={location.pathname === path}>
      {name}
    </Item>
  );
}

export const Item = styled.div<{ selected: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 4.8rem;
  width: 20rem;
  margin-bottom: 0.4rem;
  padding: 1.2rem;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
  color: ${(props) => (props.selected ? "#053692" : "#757c86")};
  border-radius: 0.8rem;
  background-color: ${(props) => (props.selected ? "#f0f5ff" : "")};
  box-sizing: border-box;
`;

export default SidebarItem;
